export default "__VITE_PUBLIC_ASSET__a7ebd3de__"